"use client";

import AuthDialog from "@/components/auth/AuthDialog";

const WRITE_REVIEW_RETURN = "/reviews?writeReview=1";

export type WriteReviewAuthDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
};

/**
 * Reviews-page auth popup: {@link AuthDialog} with a fixed post-login redirect to order history.
 * Elsewhere use `<AuthDialog returnUrl="..." showSignupTab />` from `@/components/auth`.
 */
export default function WriteReviewAuthDialog({ open, onOpenChange }: WriteReviewAuthDialogProps) {
	return (
		<AuthDialog
			open={open}
			onOpenChange={onOpenChange}
			returnUrl={WRITE_REVIEW_RETURN}
			title="Log in to write a review"
			showSignupTab={false}
		/>
	);
}

export const writeReviewAuthReturnUrl = WRITE_REVIEW_RETURN;
